export default {
  distanceToStart: 'Waktu hingga Event Dimulai',
  distanceToEnd: 'Waktu tersisa hingga event berakhir',
  ended: 'Event Selesai',
  moonPhase: {
    introduction: 'Fase bulan akan meningkat berdasarkan total progres Top Up Rainbow Diamonds dari seluruh pemain selama event berlangsung. Setelah mencapai Bulan Purnama, semua pemain yang berpartisipasi dalam event ini dapat menerima hadiah terbatas Bulan Purnama [Gelar - Bulan Purnama Festival Pertengahan Musim Gugur].',
    new_moon: 'Bulan Baru',
    crescent_moon: 'Bulan Sabit Muda',
    first_quarter: 'Bulan Separuh Pertama',
    gibbous_moon: 'Bulan Cembung Muda',
    full_moon: 'Bulan Purnama',
  },
  rewards: {
    clickHere: 'Klik di sini',
    introduceText1: 'Kunjungi Pusat Top Up Resmi [{clickHere}]. Lakukan Top Up dengan total 200/500/1.000/3.000/5.000/8.000 Rainbow Diamonds untuk mengklaim Hadiah Pencapaian.',
    introduceText2: 'Periode Event: 25 Sep 2026, 00:00 – 4 Okt 2026, 23:59 (GMT+7).',
    introduceText3: 'Batas waktu klaim hadiah adalah 4 Okt 2026, pukul 23:59 (GMT+7).',
  }
}